import React from "react";
import { socket } from "../../../lib/socketio";
import { CtrLTemplate, GroupTemplate } from "../../Definitions/cl";
import { Grid } from "semantic-ui-react";
import ControlGroupColumn from "../../Monitor/ControlLoops/ControlGroupColumn";
import ControlColumn from "../../Monitor/ControlLoops/ControlColumn";
import Footer from "../Footer";

import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { setCurrentPLC, setUserArray } from "../../../actions/headerActions";
import RequestAccessModal from "../../RequestAccess/RequestAccessModal";
import { setUser } from "../../../actions/navActions";

const CathodeAnodePurgePSM4 = () => {
  const [tags, settags] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [outputTags, setOutputTags] = React.useState([]);

  const location = useLocation();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const user = useSelector((state) => state.nav.user);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const electronApp = useSelector((state) => state.nav.electronApp);
  const [userArr, setUserArr] = React.useState(null);
  const [requestor, setRequestor] = React.useState(null);
  const [pop, setPop] = React.useState(false);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  React.useEffect(() => {
    if (tags.length === 0) {
      socket.emit("get tag names", [{ display_id: 187 }, { display_id: 130 }]);
      socket.on("receive tag names", (data) => {
        settags(data.tags_data);
        setOutputTags(data.tags_data.filter((el) => el.id === 99999));
      });
    }
    return () => {
      socket.removeAllListeners();
    };
  }, [tags]);

  const ids = tags.map((t) => t.id);
  const FooterTags = tags.flatMap((t) => (t.display_id === 130 ? [t] : []));
  const GenTags = tags.flatMap((t) => (t.display_id === 187 ? [t] : []));
  const display = GenTags.map((t) => t.page_name);

  const GroupTags = CtrLTemplate(
    GenTags.filter((el) => el.id !== 99999),
    "tag_display_name",
  );

  const ClTags = GroupTemplate(GroupTags[0], "tag_display_subgroup");
  const GroupTagsOutput = CtrLTemplate(outputTags, "tag_display_name");

  React.useEffect(() => {
    if (!electronApp) {
      var currentClient = `${user.name}:${socket.id}:${userCopy.hmi_role}`;
      socket.on("userDict", (response) => {
        let res = response[currentPLC];

        if (res.indexOf(currentClient) === 1) {
          if (userCopy.hmi_role !== user.hmi_role) {
            user.hmi_role = userCopy.hmi_role;
            dispatch(setUser(user));
          }
        } else {
          dispatch(setUserArray(response));

          for (var i = 2; i < res.length; i++) {
            var info = res[i].split(":");
            if (user.name === info[0]) {
              user.hmi_role = "E";
              setUser(user);
            }
          }
        }
      });
      socket.on("permission", (data) => {
        setUserArr(data.mainArr); // local variable
        setRequestor(data.requestor);
        setPop(true);
      });
      socket.on("access granted", (response) => {
        let data = response[currentPLC];
        if (data.indexOf(currentClient) === 1) {
          user.hmi_role = userCopy.hmi_role;
          dispatch(setUser(user));
        } else {
          dispatch(setUserArray(response));
          user.hmi_role = "E";
          dispatch(setUser(user));
        }
      });
      socket.on("access denied", () => {
        alert("ACCESS DENIED");
      });
      socket.on("access transferred", (data) => {
        alert(
          `Access has been tranferred to ${data.requested.split(":")[0]}. Comment: ${data.comment}`,
        );
      });
    }
    if (ids.length > 0) {
      socket.emit("get tag values", ids);
      socket.on("receive tag values", (value) => {
        setData(value.result);
      });

      return () => {
        socket.removeAllListeners();
      };
    }
  }, [ids, data]);

  const cctags = [];
  let rowsg;
  const clength = ClTags[0].length;
  rowsg = Math.round(clength / 2);
  let j = 0;
  while (j < clength) {
    cctags.push(ClTags[0].slice(j, j + rowsg));
    j += rowsg;
  }

  const handleYes = () => {
    socket.emit("grant access", {
      message: "YES",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };
  const handleNo = () => {
    socket.emit("grant access", {
      message: "NO",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };

  return (
    <div style={styles.div}>
      {!electronApp && pop && (
        <RequestAccessModal
          pop={pop}
          yes={handleYes}
          no={handleNo}
          reqq={requestor.split(":")[0]}
        />
      )}
      <h1 style={styles.header}>{display[0]}</h1>
      <Grid inverted divided centered columns="equal">
        <Grid.Column
          style={{
            maxWidth: "800px",
            marginLeft: "50px",
            marginBottom: "10px",
          }}
        >
          <Grid inverted divided centered columns="equal">
            <ControlColumn column={GroupTagsOutput[0]} data={data} />
          </Grid>
        </Grid.Column>
      </Grid>
      <Grid inverted divided centered columns="equal" style={styles.grid}>
        <Grid.Column>
          <Grid inverted divided centered columns="equal" style={styles.grid}>
            {cctags.map((c, i) => (
              <ControlGroupColumn
                index={i}
                column={c}
                data={data}
                property={2}
              />
            ))}
          </Grid>
        </Grid.Column>
      </Grid>
      <div style={styles.divFooter}>
        <Footer tags={FooterTags} data={data} />
      </div>
    </div>
  );
};

const styles = {
  div: {
    textAlign: "center",
  },
  divFooter: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 1 auto",
    width: "100%",
  },
  toggle: {
    marginLeft: "8px",
  },
  grid: {
    margin: "0",
    marginLeft: "20px",
  },
};

export default CathodeAnodePurgePSM4;
